/* global localStorage */

import User from '@/models/User'
import * as MutationTypes from './mutation-types'

const state = {
  token: localStorage.token,
  user: User.from(localStorage.token)
}

const mutations = {
  [MutationTypes.TOKEN] (state, payload) {
    state.token = payload
  },
  [MutationTypes.LOGIN] (state) {
    state.user = User.from(localStorage.token)
  },
  [MutationTypes.LOGOUT] (state) {
    state.user = null
  }
}

const getters = {
  currentUser (state) {
    return state.user
  },

  currentToken (state) {
    return state.token
  }
}

const actions = {
  token ({ commit }, payload) {
    commit(MutationTypes.TOKEN)
  },

  login ({ commit }) {
    commit(MutationTypes.LOGIN)
  },

  logout ({ commit }) {
    commit(MutationTypes.LOGOUT)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
